import { useLoaderStyles } from '@global-dax-ad-platform/dax-styles';
import { Box, CircularProgress } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

type LoadableComponentProps = {
  loading: boolean;
  children?: React.ReactNode;
};

const LoadableComponent = ({ loading, children }: LoadableComponentProps) => {
  const loaderClasses = useLoaderStyles();
  return (
    <>
      {loading ? (
        <Box className={loaderClasses.container} style={{ marginTop: '16px' }}>
          <CircularProgress />
        </Box>
      ) : (
        children
      )}
    </>
  );
};

export default LoadableComponent;
